$(document).on("turbolinks:load", function () {
  var $prodFiles = $(".js-productReview-files-flag")
  var $primaryInfo = $(".js-productReview-primary-info-flag")
  var $categoriesSoftwareLicense = $(
    ".js-productReview-categories-software-licensing-flag"
  )
  var $productPage = $(".js-productReview-product-page-flag")
  var $prodImages = $(".js-productReview-images-flag")
  var $prodVariations = $(".js-productReview-variations-flag")
  var $docsFaqs = $(".js-productReview-docs-faq-flag")
  var $prodReviewSubmitBtn = $(".js-submit-product-review")

  var $flagsAndSubmit = [
    $prodFiles,
    $primaryInfo,
    $categoriesSoftwareLicense,
    $productPage,
    $prodImages,
    $prodVariations,
    $docsFaqs,
    $prodReviewSubmitBtn,
  ]

  $(".js-productReview-reviewMessage").summernote("reset")

  $flagsAndSubmit.map(function (e) {
    e.on("click", function (e) {
      var $flag = $(e.target)
      var $isFlagged = $flag.attr("data-isflagged")
      updateFlag($flag, $isFlagged)
      sendFlag($flag)
    })
  })

  toggleGrantTrusted()
  $("#product_review_file_status, #product_review_page_status").on(
    "change",
    toggleGrantTrusted
  )
})

// Granting Trusted status is only allowed on a review that approves the product
function toggleGrantTrusted() {
  var $grantTrusted = $(".js-productReview-grantTrusted")
  var completed =
    $("#product_review_file_status").val() === "completed" &&
    $("#product_review_page_status").val() === "completed"

  $grantTrusted.prop("disabled", !completed)
  if (!completed) $grantTrusted.prop("checked", false)
}

function updateFlag($flag, isFlagged) {
  var $navFlag = findNavFlag($flag)

  if (isFlagged === "false") {
    $flag.removeClass("far").addClass("fas flagged")
    $flag.attr("data-isflagged", true)
    $navFlag.removeClass("d-none")
  } else if (isFlagged === "true") {
    $flag.removeClass("fas flagged").addClass("far")
    $flag.attr("data-isflagged", false)
    $navFlag.addClass("d-none")
  }
}

function sendFlag(flag) {
  var flagSelectorDataAttr = flag.attr("data-isflagged")
  var flagChecked = flagSelectorDataAttr === "true"

  if (flag.hasClass("js-productReview-files-flag")) {
    $("#product_review_product_files").val(flagSelectorDataAttr)
    updateReviewMessage("Product Files", flagChecked)
  } else if (flag.hasClass("js-productReview-primary-info-flag")) {
    $("#product_review_primary_info").val(flagSelectorDataAttr)
    updateReviewMessage("Primary Info", flagChecked)
  } else if (
    flag.hasClass("js-productReview-categories-software-licensing-flag")
  ) {
    $("#product_review_categories_software_and_licensing").val(
      flagSelectorDataAttr
    )
    updateReviewMessage("Categories, Software &amp; Licensing", flagChecked)
  } else if (flag.hasClass("js-productReview-product-page-flag")) {
    $("#product_review_product_page").val(flagSelectorDataAttr)
    updateReviewMessage("Product Page", flagChecked)
  } else if (flag.hasClass("js-productReview-images-flag")) {
    $("#product_review_image_gallery").val(flagSelectorDataAttr)
    updateReviewMessage("Image Gallery", flagChecked)
  } else if (flag.hasClass("js-productReview-variations-flag")) {
    $("#product_review_product_variations").val(flagSelectorDataAttr)
    updateReviewMessage("Product Variations", flagChecked)
  } else if (flag.hasClass("js-productReview-docs-faq-flag")) {
    $("#product_review_docs_and_faq").val(flagSelectorDataAttr)
    updateReviewMessage("Documentation &amp; FAQ", flagChecked)
  }
}

function findNavFlag($flag) {
  // Splits up the list of class names on a flag, and then appends '-nav' to the found class name
  var $flagClassAry = $flag.attr("class").split(" ")
  var findFlag = $flagClassAry.find((className) =>
    className.startsWith("js-productReview")
  )
  var classNav = findFlag + "-nav"
  return $("." + classNav)
}

function updateReviewMessage(header, flagChecked) {
  prependMessageIfFlagged()

  if (flagChecked) {
    addHeaderToReviewMessage(header)
  } else {
    removeHeaderFromReviewMessage(header)
  }
}

function addHeaderToReviewMessage(header) {
  var $reviewMessage = $(".js-productReview-reviewMessage")
  var text = $reviewMessage.summernote("code")

  // Account for blank/empty form
  if (text == "<p><br></p>") {
    text = ""
  }

  // Add header if not present
  if (!text.includes("<p><strong>" + header + "</strong></p>")) {
    text += "<p><strong>" + header + "</strong></p>"
    text += "<p>&nbsp;</p>"
  }

  $reviewMessage.summernote("code", text)
}

function removeHeaderFromReviewMessage(header) {
  var $reviewMessage = $(".js-productReview-reviewMessage")
  var text = $reviewMessage.summernote("code")

  // Build regex based on provided header to remove it
  // <p><strong>HEADER</strong></p> followed by an optional <p>&nbsp;</p> with possible whitespace in between.
  const escapedHeader = header.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  const headerRegex = new RegExp(
    `<p><strong>${escapedHeader}</strong></p>(?:\\s*<p>&nbsp;</p>)?`,
    "igm"
  )

  var newText = text.replace(headerRegex, "")
  $reviewMessage.summernote("code", newText)
}

function prependMessageIfFlagged() {
  var $reviewMessage = $(".js-productReview-reviewMessage")
  var $productTitle = $(".js-product-review-prod-title").text()
  var isAnyFlagged = $(".fa-flag.flagged").length > 0

  var prependedMessage = `
    <p class="prepended-review-message">
      Hi there.<br><br>
      I have reviewed your product <strong>${$productTitle} </strong>. <br>
      Below are some updates we would like you to make before we can approve the product.<br>
      </p>
  `

  if (isAnyFlagged && $(".prepended-review-message").length === 0) {
    $reviewMessage.summernote("code", prependedMessage)
  } else if (!isAnyFlagged && $(".prepended-review-message").length > 0) {
    $(".prepended-review-message").remove()
  }
}
